import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { LOOKUP, LOOKUPMAIN } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { HlookupsAddMultipleComponent } from '../hlookups-add-multiple/hlookups-add-multiple.component';
import { CommonService } from 'src/app/services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-hlookups-modal-edit',
  templateUrl: './hlookups-modal-edit.component.html',
  styleUrls: ['./hlookups-modal-edit.component.scss']
})
export class HlookupsModalEditComponent implements OnInit {
  @Input() public Content: any;
  isAllowNew: boolean = false;
  lookupList: LOOKUP[];
  lookupMain: LOOKUPMAIN;
  lookupListVal: LOOKUP;
  hideActive: boolean = false;
  action: Subject<any> = new Subject();
  Module: any;
  Modulecode: any;
  lookup: LOOKUP;
  categoryForm: UntypedFormGroup;

  constructor(
    private modalService: NgbModal,
    public ModalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    if (this.Content.IsAllowNew == "Yes" || this.Content.heading == "Edit" || this.Content.heading == "Add")
      this.isAllowNew = true;
    else
      this.isAllowNew = false;
    this.getLookups();
    this.categoryForm = new UntypedFormGroup({
      category: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
      subCategory: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)])
    }
    );
  }

  getLookups() {
    this.summaryService.getHLookupsSummary(this.Content.id).subscribe(summary => {
      this.lookupMain = summary;
      this.categoryForm.controls["category"].setValue(summary.categoryName);
      this.categoryForm.controls["subCategory"].setValue(summary.subCategoryName);
      this.lookupList = summary.lookuplist;

    });
  }

  selectDocuments(event, firstLevelId: any, lookup) {
    let ISParent = true;
   

    if (event == "Add" || event == "AddChild") {
      if (event == "Add") {
        this.Content.heading = "Add";
      } else {
        this.Content.heading = "AddChild";
        ISParent = false;
      }
      let modalRef = this.modalService.open(HlookupsAddMultipleComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: this.Content.heading,
          id: this.lookupMain.lookupType,
          IsParent: ISParent,
          FirstLevelID: firstLevelId,
          Module: this.Content.Module,
          parentName: (lookup == undefined ||lookup==null) ? "" : lookup.NAME,
          list: this.lookupList

      }

    
    }

    if (event == "Edit") {
      let modalRef = this.modalService.open(HlookupsAddMultipleComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg ',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: 'Edit',
        id: this.lookupMain.lookupType, IsParent: ISParent, FirstLevelID: lookup.ID, Module: this.Content.Module,
        Name: lookup.NAME, RecordState: lookup.RECORD_STATE,
        list: this.lookupList

      }
      modalRef.result.then(result => {
        if (result) {
          let isExist = this.lookupList.find(x => x.NAME == result.NAME && x.RECORD_STATE == result.RECORD_STATE);
          if (!isExist) {
            let find = this.lookupList.findIndex(x => x.ID == result.ID);
            this.lookupList[find].NAME = result.NAME;
            this.lookupList[find].RECORD_STATE = result.RECORD_STATE;
          }
         

        }
      });
    }

    if (event == "EditChild") {
      let modalRef = this.modalService.open(HlookupsAddMultipleComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg ',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: 'Edit',
        id: this.Content.id, IsParent: false, FirstLevelID: firstLevelId, Module: this.Content.Module,
        Name: lookup.NAME, RecordState: lookup.RECORD_STATE, parentName: firstLevelId.NAME, ID: lookup.ID, list: this.lookupList, head: "EditChild"

      }
      modalRef.result.then(result => {
        let lkup: any;
        let find: any;
        if (result) {
          lkup = this.lookupList.find(x => x.ID == result.DEFAULT_ID);
          let isExist = lkup["ChildData"].find(x => x.NAME == result.NAME && x.RECORD_STATE == result.RECORD_STATE);
          if (!isExist) {
            find = lkup["ChildData"].findIndex(x => x.ID == result.ID);
            lkup["ChildData"][find].NAME = result.NAME;
            lkup["ChildData"][find].RECORD_STATE = result.RECORD_STATE;

          }
         
        }
      });
    }
  }

  Save(): void {
    let subValList = [];
    let childExist = true;
    let suprtValName = "";
    let program = "";
    let module = "";
    if (this.validateFormControl()) {
      this.lookupList.forEach(element => {
        if (element["ChildData"].length == 0) {
          childExist = false;
          suprtValName = element.NAME;
          subValList.push(suprtValName);
        }
      });

      if (this.lookupList.length >= 1) {
        if (childExist) {
          for (let i = 0; i < this.lookupList.length; i++) {
            if (this.lookupList[i].RECORD_STATE)
              this.lookupList[i].RECORD_STATE = 1;
            else
              this.lookupList[i].RECORD_STATE = 0;

            for (let j = 0; j < this.lookupList[i]["ChildData"].length; j++) {
              if (this.lookupList[i]["ChildData"][j].RECORD_STATE)
                this.lookupList[i]["ChildData"][j].RECORD_STATE = 1;
              else
                this.lookupList[i]["ChildData"][j].RECORD_STATE = 0;
            }

            this.lookupList[i]["CATEGORY"] = this.categoryForm.controls["category"].value + "/" + this.categoryForm.controls["subCategory"].value;
            this.lookupList[i]["PROGRAM"] = this.Content.Module;
          }
          var lookupmain = new LOOKUPMAIN();
          lookupmain.ID = this.Content.id;
          lookupmain.categoryName = this.categoryForm.controls["category"].value;
          lookupmain.subCategoryName = this.categoryForm.controls["subCategory"].value;
          lookupmain.moduleID = this.Content.Module;
          lookupmain.lookuplist = this.lookupList;
          this.summaryService.updateHLookups(lookupmain).subscribe(summary => {
            if (summary.Status === 0) {
              this.commonService.SuccessBanner("'" + lookupmain.categoryName + "/" + lookupmain.subCategoryName + "'" + ' details updated successfully');
              this.close();
            } else {
              this.commonService.ValidationBanner(summary.Message);
            }

          });
        } else {
          this.commonService.ValidationBanner("Please add sub-values against '" + subValList.join(', ') + "' to save the details");
        }
      } else {
        this.commonService.ValidationBanner("Please add at least one value to save the configuration");
      }
    }
  }

  validateFormControl() {
    let valid: boolean = true;
    let errMsg = [];
    if (!this.categoryForm.controls['category'].value || !this.categoryForm.controls['category'].value.trim()) {
      valid = false;
      errMsg.push("Please enter category name");
    }
    if (!this.categoryForm.controls['subCategory'].value || !this.categoryForm.controls['subCategory'].value.trim()) {
      valid = false;
      errMsg.push("Please enter subcategory name");
    }

    if (errMsg && errMsg.length > 0) {
      let errstring = errMsg.join("<br>");
      this.commonService.ValidationBanner(errstring);
    }
    return valid;
  }

  Delete(event, lookupId): void {

    let checkSingle = this.lookupList.find(x => x.ID == lookupId);
    if (checkSingle['ChildData'].length > 0) {
      
      event.ParentID = lookupId;
      this.summaryService.deleteHLookups(event).subscribe(summary => {
        if (summary.Status === 0) {
          this.commonService.ValidationBanner(summary.Message);
        }
        else {
          let val = this.lookupList.find(x => x.ID == lookupId);
          let listVal = val["ChildData"].findIndex(x => x.ID == event.ID);

          if (val["ChildData"].length > 0) {

            val["ChildData"].splice(listVal, 1);
          }
        }
      });
    }
  }

  validateChild() {
    let childExist = true;
    this.lookupList.forEach(element => {
      if (this.lookupList["ChildData"].length < 0) {
        childExist = false;
      }
    });
    return childExist;
  }

  listSorted(event: any) {
   
  }

  close() {
    this.ModalRef.close();
  
  }
  Cancel() {
    this.ModalRef.dismiss();
  }
}
